// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__0OnCC","modalContent":"modal_modalContent__PAIU5"};